import { useToken } from './useToken';
export const IfAnonymousUser = ({
  children
}) => {
  const {
    isAnonymousUser
  } = useToken();
  if (isAnonymousUser) {
    return children;
  }
  return null;
};
//# sourceMappingURL=IfAnonymousUser.js.map